import { showToast } from "@/helpers/toast"
import { TAGS, api } from "@/store/api"
import type {
  IFriendLobbyPreviewResponse,
  IJoinFriendLobbyResponse,
  IMyFriendLobbyResponse
} from "./friendLobby.types"

const basePath = "/friend-lobbies"

const friendLobbyApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.FRIEND_LOBBY]
})

export const friendLobbyEndpoints = friendLobbyApi.injectEndpoints({
  endpoints: (builder) => ({
    createFriendLobby: builder.mutation<IMyFriendLobbyResponse, void>({
      query: () => ({ url: basePath, method: "POST" }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(
            friendLobbyEndpoints.util.upsertQueryData(
              "getMyFriendLobby",
              undefined,
              data
            )
          )
        } catch (error) {
          console.error(error)
        }
      }
    }),

    getMyFriendLobby: builder.query<IMyFriendLobbyResponse, void>({
      query: () => ({ url: `${basePath}/me`, method: "GET" }),
      providesTags: [{ type: TAGS.FRIEND_LOBBY, id: "ME" }]
    }),

    cancelMyFriendLobby: builder.mutation<void, void>({
      query: () => ({ url: `${basePath}/me`, method: "DELETE" }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled
          dispatch(
            friendLobbyEndpoints.util.invalidateTags([
              { type: TAGS.FRIEND_LOBBY, id: "ME" }
            ])
          )
        } catch {
          showToast.error("Failed to cancel friend lobby")
        }
      }
    }),

    previewFriendLobby: builder.query<IFriendLobbyPreviewResponse, string>({
      query: (token) => ({
        url: `${basePath}/preview/${token}`,
        method: "GET"
      }),
      providesTags: (_, __, token) => [{ type: TAGS.FRIEND_LOBBY, id: token }]
    }),

    joinFriendLobby: builder.mutation<IJoinFriendLobbyResponse, string>({
      query: (token) => ({ url: `${basePath}/join/${token}`, method: "POST" })
    })
  })
})

export const {
  useCreateFriendLobbyMutation,
  useGetMyFriendLobbyQuery,
  useLazyGetMyFriendLobbyQuery,
  useCancelMyFriendLobbyMutation,
  usePreviewFriendLobbyQuery,
  useJoinFriendLobbyMutation
} = friendLobbyEndpoints
